import { z } from "zod";

/** Ödeme sağlayıcısı entegrasyonu: İyzico (satış kanalı değildir; yalnız ödemeleri okur). */

export const iyzicoConnectSchema = z.object({
  apiKey: z.string().trim().min(10, "API anahtarını girin").max(200),
  secretKey: z.string().trim().min(10, "Gizli anahtarı girin").max(200),
  environment: z.enum(["live", "sandbox"]).default("live"),
});
export type IyzicoConnectInput = z.infer<typeof iyzicoConnectSchema>;

export interface IyzicoStatusDto {
  connected: boolean;
  environment: "live" | "sandbox" | null;
  /** API anahtarının son karakterleri (tam değer asla dönmez). */
  apiKeyHint: string | null;
  connectedAt: string | null;
  lastCheckedAt: string | null;
  lastError: string | null;
  canManage: boolean;
}

export const IYZICO_TX_TYPE_LABELS = { payment: "Ödeme", refund: "İade", cancel: "İptal" } as const;
export type IyzicoTxType = keyof typeof IYZICO_TX_TYPE_LABELS;
export const IYZICO_TX_STATUS_LABELS = { approved: "Onaylandı", review: "Kontrolde", rejected: "Reddedildi" } as const;
export type IyzicoTxStatus = keyof typeof IYZICO_TX_STATUS_LABELS;

export interface IyzicoTransactionDto {
  id: string;
  type: IyzicoTxType;
  /** İşlem zamanı (ISO, İstanbul saatiyle gelen değer çevrilir). */
  at: string;
  paymentId: string | null;
  basketId: string | null;
  /** Panelde eşleşen sipariş (sepet numarası sipariş numarasıysa). */
  order: { id: string; number: string } | null;
  price: string;
  paidPrice: string;
  currency: string;
  installment: number;
  /** İyzico komisyonu + işlem ücreti (yalnız ödemede). */
  commission: string | null;
  /** Mağazaya geçecek tutar (yalnız ödemede). */
  net: string | null;
  status: IyzicoTxStatus;
  threeDS: boolean;
  afterSettlement: boolean;
}

export const iyzicoTransactionsQuerySchema = z.object({
  days: z.coerce.number().int().min(1).max(31).default(7),
  type: z.enum(["all", "payment", "refund", "cancel"]).default("all"),
});

export interface IyzicoTransactionsResponse {
  from: string;
  to: string;
  items: IyzicoTransactionDto[];
  totals: { payments: number; paid: string; refunded: string; commission: string; net: string };
  /** Okunamayan günler (ör. istek sınırı). */
  failedDays: string[];
}

export interface IyzicoPaymentDetailDto {
  paymentId: string;
  status: "success" | "failure" | "pending";
  refundStatus: "none" | "partial" | "full";
  fraud: IyzicoTxStatus;
  price: string;
  paidPrice: string;
  currency: string;
  installment: number;
  commission: string;
  card: { type: string | null; association: string | null; family: string | null; lastFour: string | null };
  bank: string | null;
  threeDS: boolean;
  createdAt: string | null;
  refunds: { amount: string; at: string | null }[];
  /** Blokaj çözülme (ödeme) tarihi. */
  payoutDate: string | null;
}
